export const CREATE_YACHT = "CREATE_YACHT";
export const UPDATE_YACHT = "UPDATE_YACHT";
export const DELETE_YACHT = "DELETE_YACHT";
export const FETCH_YACHTS = "FETCH_YACHTS";
export const LISTEN_TO_SELECTED_YACHT = "LISTEN_TO_SELECTED_YACHT";
